<template>
        <div class="col-md-6 offset-md-3" style="padding:15px">

            <div id=loginDiv>
                
                    <router-link to="/">
                        <img id="logoLoginPage" src="/images/openplan.png" alt="logo Prolendar">
                    </router-link>
            
           
        <h2>Login</h2>
        <transition name="slide-fade">
            <form @submit.prevent="onSubmit">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" placeholder="Username" v-model.trim="v$.username.$model" name="username" class="form-control" :class="{ 'is-invalid': submitted && v$.username.$error }" />
                    <div v-if="submitted && v$.username.required.$invalid" class="invalid-feedback">Username is required</div>
                </div>
                <div class="form-group" style="margin-bottom:30px">
                    <label htmlFor="password">Password</label>
                <input type="password" placeholder="Password" v-model.trim="v$.password.$model" name="password" class="form-control" :class="{ 'is-invalid': submitted && v$.password.$error }" />
                    <div v-if="submitted && v$.password.required.$invalid" class="invalid-feedback">Password is required</div>
                    <!-- <div style="margin-top:15px; border: 1px black solid"> -->
                    <p style="text-align: right; margin-top:12px; font-size: 11px"><router-link :to="{name:'resetpasswordrequest'}">Forgot Password?</router-link></p>
                    <!-- </div> -->        
                    
                    </div>
                <div class="form-group">
                    <button style="width: 100%; background-color: rgb(0, 125, 252)" class="btn btn-edit"  :disabled="loading">Login</button>
                    <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                </div>
            <div v-if="error" class="alert alert-danger">{{error}}</div>
            </form>
        </transition>
<!-- 
        Here is a fragment which will be usefull when we'll be enable peple to Register themselves.
        <br>
        <div style="padding:20px">
            <div id="footerLoginDiv">
                <p style="text-align:center; font-size:12px; margin-top:8px">Don't have an account? <router-link :to="{path:'/register'}">Sign Up</router-link></p>
                <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />

            </div>
        </div> -->

         <!-- <div class="form-group">
                <router-link :to="{path:'/register'}"><button class="btn btn-primary">Register</button></router-link>
                <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div> -->
    </div>
    <div style="justify-content: center;margin-top: 20px;display: flex;">
        <a href="https://apps.apple.com/gb/app/prolendar/id1315846400?ign-mpt=uo%3D2" target="_blank">
                        <img style="height: 30px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadfromappstore.png" alt="download from Apple Store icon">
                </a>
                <a style="margin-left:60px;" href="https://play.google.com/store/apps/details?id=com.prolendar.prolendarnew&hl=en" target="_blank">
                        <img style="height: 29px; width:100px; border-radius: 6px;" id="downloadButtons" src="/images/downloadfromgoogleplay.png" alt="download from Google Play icon">
                </a>
    </div>
    </div>
</template>

<style scoped>
#tableForGooglePlay{
    margin: auto;
    width: 40%;
    margin-top: 13px
}

#loginDiv{
    margin: auto;
    width: 330px;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white
}
#logoLoginPage{
    height: auto;
    width: 70%;
    display: block;
    margin-left: auto;
    margin-right: auto;    
}

h2{
    text-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;
    
}
#footerLoginDiv{
    border-top: 1px solid rgb(182, 179, 179);
    height: 30px;
}
</style>



<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { Role } from '@/_helpers';
import { router } from '@/_helpers';
import { authenticationService } from '@/_services';

export default {
    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            returnUrl: '',
            error: '',
            currentUser: null
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
      username: { required },
      password: { required }
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        },
        isAdmin() {
            return this.currentUser && this.currentUser.role === Role.Admin;
            },
        isOwner(){
            return this.currentUser && this.currentUser.role === Role.Owner;
        },
         user() {
            return authenticationService.currentUserValue;
        },
        users () {
            return this.$store.state.users.all;
        },
        getReturnUrl(){
            if(this.isAdmin)
               return  'buildings'
            else if(this.isOwner)
               return  'propertiesowner'
            else
               return '/'
        }
    },
    created () {
        this.returnUrl = this.getReturnUrl;
        // redirect to home if already logged in
        const loggedInUser = authenticationService.currentUserValue;
        if (loggedInUser) {
            if (loggedInUser.role === Role.Admin || loggedInUser.role === Role.Management)
                this.$router.replace({ name: 'buildings' });
            else if (loggedInUser.role === Role.Owner)
                this.$router.replace({ name: 'propertiesowner' });
            else
                this.$router.replace('/');
            return;
        }

        // get return url from route parameters or default to '/'
       
       
    },
    methods: {

        // NOW IT OPENS HOME PAGE FOR OWNERS AND BUILDING PAGE FOR ADMINISTRATION

        onSubmit () {
            this.submitted = true;

            // stop here if form is invalid
            this.v$.$touch();
            if (this.v$.$invalid) {
                return;
            }

            this.loading = true;
            authenticationService.login(this.username, this.password)
                .then(
                    user => {
                        //console.log(this.getReturnUrl())
                        if(user.role === Role.Admin)
                            router.push( {name:'buildings'})
                        else if(user.role === Role.Owner)
                            router.push( {name:'propertiesowner'})
                        else
                            router.push('/')
                            }
                        ,
                    error => {
                        this.error = error;
                        this.loading = false;
                    }
                );
        }
    }
};
</script>